export default function ({ store, redirect }) {
  if (!store.getters['user/allEnabledFeatures'].includes('octopus-money-ani')) {
    return redirect('/');
  }
}
